export class SidebarEvent {
  public isSidebarFixed = true;

  initializeSidebar() {
    const hamBurger = document.querySelector('.toggle-btn') as HTMLElement;
    const sidebar = document.getElementById('sidebar') as HTMLElement | null;
    const content = document.querySelector('.content') as HTMLElement | null;
    const topbar = document.querySelector('.topbar') as HTMLElement | null;
    const logobox = document.querySelector('.logobox') as HTMLElement | null;
    const pageFooter = document.querySelector('.page-footer') as HTMLElement | null;
    const togglebutton = document.querySelector('.mobile-toggle-menu') as HTMLElement;

    if (!sidebar || !content || !topbar || !logobox || !pageFooter) {
      // Handle case when any of these elements is missing in the DOM
      // console.error('One or more required elements are missing in the DOM');
      return;
    }

    let isSidebarFixed = false;

    const toggleSidebar = () => {

      this.isSidebarFixed = !this.isSidebarFixed;

      const isMobileView = window.innerWidth;

      if (isMobileView > 1024) {
      if (this.isSidebarFixed) {
        sidebar.classList.add('expand');
        sidebar.classList.remove('collapsed');
        content.classList.add('expanded');
        content.classList.remove('collapsed');
        topbar.classList.add('expanded');
        topbar.classList.remove('collapsed');
        logobox.classList.add('expanded');
        logobox.classList.remove('collapsed');
        pageFooter.classList.add('expanded');
        pageFooter.classList.remove('collapsed');
      } else {
        sidebar.classList.toggle('collapsed');
        sidebar.classList.toggle('expand');

        const isCollapsed = sidebar.classList.contains('collapsed');

        content.classList.toggle('collapsed', isCollapsed);
        content.classList.toggle('expanded', !isCollapsed);
        topbar.classList.toggle('collapsed', isCollapsed);
        topbar.classList.toggle('expanded', !isCollapsed);
        logobox.classList.toggle('collapsed', isCollapsed);
        logobox.classList.toggle('expanded', !isCollapsed);
        pageFooter.classList.toggle('collapsed', isCollapsed);
        pageFooter.classList.toggle('expanded', !isCollapsed);
      }
      } else {
        console.log(isMobileView, 'botton');
        sidebar.classList.add('expand');
        sidebar.classList.remove('collapsed');
        content.classList.add('expanded');
        content.classList.remove('collapsed');
        topbar.classList.add('expanded');
        topbar.classList.remove('collapsed');
        logobox.classList.add('expanded');
        logobox.classList.remove('collapsed');
        pageFooter.classList.add('expanded');
        pageFooter.classList.remove('collapsed');
        sidebar.style.display = 'none';
      }
    };

    // Ensure the elements are not null before adding event listeners
    if (hamBurger) {
      hamBurger.addEventListener('click', toggleSidebar);
    }

    if (togglebutton) {
      togglebutton.addEventListener('click', () => {
        if (sidebar) {
          sidebar.classList.add('expand');
          topbar.classList.add('expanded');
          logobox.classList.add('expanded');
          pageFooter.classList.add('expanded');
          sidebar.classList.remove('collapsed');
          logobox?.classList.remove('collapsed');
          pageFooter.classList.remove('collapsed');
          sidebar.style.display = 'block';
        }
      });
    }

    // Add mouse enter and leave events for expanding and collapsing the sidebar

    sidebar.addEventListener('mouseenter', () => {

      if(window.innerWidth>1025){
      sidebar.classList.add('expand');
      sidebar.classList.remove('collapsed');
      content.classList.add('expanded');
      content.classList.remove('collapsed');
      topbar.classList.add('expanded');
      topbar.classList.remove('collapsed');
      logobox.classList.add('expanded');
      logobox.classList.remove('collapsed');
      pageFooter.classList.add('expanded');
      pageFooter.classList.remove('collapsed');
   } });

    sidebar.addEventListener('mouseleave', () => {

      if(window.innerWidth>1025){
      if (!this.isSidebarFixed) {
        // Only collapse if sidebar is not fixed
        sidebar.classList.add('collapsed');
        sidebar.classList.remove('expand');
        content.classList.add('collapsed');
        content.classList.remove('expanded');
        topbar.classList.add('collapsed');
        topbar.classList.remove('expanded');
        logobox.classList.add('collapsed');
        logobox.classList.remove('expanded');
        pageFooter.classList.add('collapsed');
        pageFooter.classList.remove('expanded');
      }
   } });
  }

  handleResize() {
    const sidebar = document.getElementById('sidebar');

    const logobox = document.querySelector('.logobox') as HTMLElement | null;
    const topbar = document.querySelector('.topbar') as HTMLElement | null;
    const isMobileView = window.innerWidth < 1024;

    if (sidebar) {
      if (isMobileView) {
        sidebar.style.display='none'
        sidebar.classList.add('expand');
        logobox?.classList.add('expanded');
        topbar?.classList.add('expanded');
        sidebar.classList.remove('collapsed');
        logobox?.classList.remove('collapsed');
        topbar?.classList.add('collapsed');
      } else {
        sidebar.classList.remove('collapsed');
        logobox?.classList.remove('collapsed');
        topbar?.classList.remove('collapsed');
        logobox?.classList.add('expanded');
        sidebar.style.display = 'block';
      }
    }
  }
}
